import axios from "axios";
import { getApiBaseUrl, getBackendBaseUrl } from "../utils/apiConfig";

/**
 * Create a new hotel listing
 * @param {Object} listingData - Data of the hotel listing
 * @param {File[]} imageFiles - Array of image files to upload
 */
export const createHotelListing = async (listingData, imageFiles = []) => {
  try {
    const backendUrl = getBackendBaseUrl();
    const hotelsApiUrl = `${getApiBaseUrl()}/hotels`;

    // 1. Upload images first if there are files
    const uploadedImageUrls = [];

    for (let i = 0; i < imageFiles.length; i++) {
      const formData = new FormData();
      formData.append("file", imageFiles[i]);

      const res = await axios.post(`${backendUrl}/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      uploadedImageUrls.push(res.data.path);
    }

    // 2. Prepare payload with uploaded images
    const payload = { ...listingData, imageUrls: uploadedImageUrls };

    // 3. Send hotel listing creation request
    const response = await axios.post(`${hotelsApiUrl}/hotel-listing`, payload);

    return response.data;

  } catch (error) {
    console.error("Error creating hotel listing:", error);
    throw error;
  }
};

export const getHotelListings = async (date) => {
  try {
    const hotelsApiUrl = `${getApiBaseUrl()}/hotels`;
    const response = await axios.get(`${hotelsApiUrl}/listings-with-details`, {
      params: date ? { date } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching hotel listings:", error);
    throw error;
  }
};

export const getHotelListingById = async (id) => {
  try {
    const hotelsApiUrl = `${getApiBaseUrl()}/hotels`;
    const response = await axios.get(`${hotelsApiUrl}/listings/${id}`);
    return response.data; // { success: true, data: {...} }
  } catch (error) {
    console.error("Error fetching hotel listing by ID:", error);
    throw error;
  }
};

export const checkListingLimit = async (userId) => {
  try {
    const backendUrl = getBackendBaseUrl();
    const res = await axios.get(`${backendUrl}/hotels/check-limit/${userId}`);
    return res.data;
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const sendLimitIncreaseRequest = async (userId, data) => {
  try {
    const backendUrl = getBackendBaseUrl();
    const res = await axios.post(
      `${backendUrl}/hotels/limit-increase-request/${userId}`,
      data
    );
    return res.data;
  } catch (err) {
    throw err.response?.data || err;
  }
};

/* Get all amenities */
export const getAmenities = async () => {
  const hotelsApiUrl = `${getApiBaseUrl()}/hotels`;
  const res = await axios.get(`${hotelsApiUrl}/amenities`);
  return res.data;
};

/* Add new amenity */
export const createAmenity = async (name) => {
  const hotelsApiUrl = `${getApiBaseUrl()}/hotels`;
  const res = await axios.post(`${hotelsApiUrl}/amenities`, { name });
  return res.data;
};

// Update hotel listing
export const updateHotelListing = async (listingId, formData) => {
  try {
    const backendUrl = getBackendBaseUrl();
    const response = await axios.put(
      `${backendUrl}/hotels/hotel-listing/${listingId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (err) {
    console.error("Failed to update hotel listing:", err);
    throw err.response?.data || err;
  }
};
